import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SynthRoast from "@/pages/SynthRoast";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App font-mono">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SynthRoast />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#fff",
            border: "1px solid #1f1f1f",
            borderRadius: 0,
            fontFamily: "JetBrains Mono, monospace",
          },
        }}
      />
    </div>
  );
}

export default App;
